import React from 'react';

const AuroraBackground = () => {
  return (
    <div className="fixed inset-0 z-0 overflow-hidden bg-[#0a0a1a]">
      {/* Dynamic Aurora Waves */}
      <div className="absolute inset-0 opacity-60">
        <div 
          className="absolute top-[20%] left-[20%] w-[50vw] h-[50vh] bg-indigo-600 rounded-full mix-blend-screen blur-[120px] animate-blob"
        ></div>
        <div 
          className="absolute top-[30%] right-[10%] w-[40vw] h-[60vh] bg-purple-600 rounded-full mix-blend-screen blur-[120px] animate-blob animation-delay-2000"
        ></div>
        <div 
          className="absolute bottom-[10%] left-[30%] w-[60vw] h-[50vh] bg-pink-600 rounded-full mix-blend-screen blur-[120px] animate-blob animation-delay-4000"
        ></div>
        <div 
          className="absolute bottom-[20%] right-[30%] w-[45vw] h-[45vh] bg-blue-600 rounded-full mix-blend-screen blur-[120px] animate-blob"
          style={{ animationDuration: '9s' }}
        ></div>
      </div>
      
      {/* Animated Grid Overlay */}
      <div 
        className="absolute inset-0 bg-[linear-gradient(to_right,#8080801a_1px,transparent_1px),linear-gradient(to_bottom,#8080801a_1px,transparent_1px)] bg-[size:40px_40px] animate-grid"
        style={{
          maskImage: 'linear-gradient(to bottom, transparent, black 20%, black 80%, transparent)',
          WebkitMaskImage: 'linear-gradient(to bottom, transparent, black 20%, black 80%, transparent)'
        }}
      ></div>
    </div>
  );
};

export default AuroraBackground;
